/**
 * goldenWindowRating.ts
 *
 * Centralized qualitative score reference ratings for SkySkout subjective forecasts:
 * Sunrise, Sunset, Alpenglow, Golden Hour, and Dark Skies.
 *
 * Consolidated Standard (Sunrise, Sunset, Golden Hour, Alpenglow):
 * 0 - 20:   Poor/Occluded  (Short: Poor)
 * 21 - 30:  Muted          (Short: Muted)
 * 31 - 39:  Below Average  (Short: Below Avg)
 * 40 - 59:  Average/Clear  (Short: Avg/Clear)
 * 60 - 79:  Above Average  (Short: Above Avg)
 * 80 - 100: Vivid/Burn     (Short: Vivid)
 */

export function getGoldenWindowRating(score: number): string {
  const s = Math.round(score);
  if (s <= 20) return 'Poor/Occluded';
  if (s <= 30) return 'Muted';
  if (s <= 39) return 'Below Average';
  if (s <= 59) return 'Average/Clear';
  if (s <= 79) return 'Above Average';
  return 'Vivid/Burn';
}

export function getGoldenWindowShortRating(score: number): string {
  const s = Math.round(score);
  if (s <= 20) return 'Poor';
  if (s <= 30) return 'Muted';
  if (s <= 39) return 'Below Avg';
  if (s <= 59) return 'Avg/Clear';
  if (s <= 79) return 'Above Avg';
  return 'Vivid';
}

export function getGoldenWindowRatingColor(score: number): string {
  const s = Math.round(score);
  if (s >= 80) return '#ef4444'; // Vivid/Burn
  if (s >= 60) return '#f97316'; // Above Average
  if (s >= 40) return '#eab308'; // Average/Clear
  if (s >= 31) return '#38bdf8'; // Below Average
  if (s >= 21) return '#94a3b8'; // Muted
  return '#64748b'; // Poor/Occluded
}

export function getDarkSkiesRating(score: number): string {
  if (score <= 3.0) return 'Poor';
  if (score <= 4.0) return 'Below Average';
  if (score <= 6.0) return 'Average';
  if (score <= 7.9) return 'Above Average';
  return 'Vivid';
}

export function getDarkSkiesRatingColor(score: number): string {
  if (score >= 8.0) return '#a855f7'; // Vivid
  if (score >= 6.1) return '#3b82f6'; // Above Average
  if (score >= 4.1) return '#10b981'; // Average
  if (score >= 3.1) return '#eab308'; // Below Average
  return '#94a3b8'; // Poor
}
